import { FETCH_RFI_ASYNC_ATTRIBUTES_START, injectRfiAttributes } from '../../actions';

const FETCH_RFI_FOLDER_URN_API = 'FETCH_RFI_ASYNC_ATTRIBUTES_API';
const FETCH_RFI_FOLDER_URN_API_FULFILLED = `${FETCH_RFI_FOLDER_URN_API}_FULFILLED`;
const FETCH_RFI_FOLDER_URN_API__REJECTED = `${FETCH_RFI_FOLDER_URN_API}_REJECTED`;
const TIMEOUT_THRESHOLD_MS = 1500;

const fetchRfiApiAsyncAttributesApi = ({ jsonApi, id, retryNumber = 0 }) => ({
  type: FETCH_RFI_FOLDER_URN_API,
  payload: jsonApi.getRfiById(id),
  meta: {
    retryNumber,
    id,
  },
});

export default (jsonApi) => (store) => (next) => (action) => {
  switch (action.type) {
    case FETCH_RFI_ASYNC_ATTRIBUTES_START: {
      const {
        payload: { id },
      } = action;
      setTimeout(
        () =>
          store.dispatch(
            fetchRfiApiAsyncAttributesApi({
              jsonApi,
              id,
            })
          ),
        TIMEOUT_THRESHOLD_MS
      );
      break;
    }
    case FETCH_RFI_FOLDER_URN_API_FULFILLED: {
      const maxRetry = 3;
      const {
        payload: { virtualFolderUrn },
        meta: { id, retryNumber },
      } = action;

      if (retryNumber < maxRetry) {
        if (virtualFolderUrn) {
          store.dispatch(injectRfiAttributes({ virtualFolderUrn }, id));
        }
        if (!virtualFolderUrn) {
          setTimeout(
            () =>
              store.dispatch(
                fetchRfiApiAsyncAttributesApi({
                  jsonApi,
                  id,
                  retryNumber: retryNumber + 1,
                })
              ),
            TIMEOUT_THRESHOLD_MS
          );
        }
      }
      break;
    }
    case FETCH_RFI_FOLDER_URN_API__REJECTED: {
      console.error(`${FETCH_RFI_FOLDER_URN_API__REJECTED}, info:`, action);
      break;
    }
    default:
      break;
  }

  return next(action);
};
